import { render, staticRenderFns } from "./PersonalAccessTokens.vue?vue&type=template&id=b0e8afd2"
import script from "./PersonalAccessTokens.vue?vue&type=script&lang=js"
export * from "./PersonalAccessTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports